const EducationData = [
    {
        status: 'BSc. in Computer Science and Software Engineering (CSSE)',
        year: '2018-2022',
        institute:'American International University-Bangladesh, Dhaka',
        logo: require('../../assets/educationImages/AIUB.jpg'),
        result: '3.89 in range of 4.00'
    },
    {
        status: 'Higher Secondary School Certificate (HSC)',
        year: '2014-2016',
        institute:'Govt. Tolaram College, Narayanganj',
        logo: require('../../assets/educationImages/tolaramCollege.jpg'),
        result: '5.00 in range of 5.00'
    },
    {
        status: 'Secondary School Certificate (SSC)',
        year: '2009-2014',
        institute:'I.E.T Govt. High School, Narayanganj',
        logo: require('../../assets/educationImages/IET.jpg'),
        result: '5.00 in range of 5.00'
    }
]

export default EducationData